import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, ShoppingCart } from 'lucide-react';
import logo from '../assets/logo.png';
import useCartStore from '../context/CartStore'; // Asegúrate que la ruta sea correcta

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const cartCount = useCartStore((state) => state.count); // Obtenemos el contador del store

  // Eliminamos el useEffect del localStorage y el estado local de cartItems

  // Navbar fijo al hacer scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const mainNavigation = [
    { name: 'Inicio', href: '/' },
    { name: 'Productos', href: '/products' },
    { name: 'Contacto', href: '/contact' },
    { name: 'Nosotros', href: '/about' },
    { name: 'FAQS', href: '/faqs' },

  ];

  const dropdownNavigation = [
    { name: 'Testimonios', href: '/testimonials' },
    { name: 'Terms', href: '/terms' },
  ];

  return (
    <nav className={`bg-white shadow-lg sticky top-0 z-50 ${isScrolled ? 'shadow-md' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <div className="flex">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img
                src={logo}
                alt="Logo Sahez Medic - Tienda de suministros médicos"
                className="h-8 w-8 object-contain"
                aria-hidden="false"
              />
              <span className="ml-2 text-xl font-bold text-dark">SAHEZ MEDIC</span>
            </Link>
          </div>

          {/* Menú desktop */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            {mainNavigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-3 py-2 rounded-md text-md font-medium ${
                  location.pathname === item.href
                    ? 'text-accent'
                    : 'text-dark hover:text-primary transition-colors'
                }`}
                aria-current={location.pathname === item.href ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
            
            {/* Dropdown */}
            <div className="relative">
              <button title='Categorías'
                type="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-dark hover:text-primary focus:outline-none transition-colors"
                aria-haspopup="true"
                aria-expanded={dropdownOpen}
              >
                Otros <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              {dropdownOpen && (
                <div 
                  className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md py-1 z-50 border border-section-bg"
                  role="menu"
                >
                  {dropdownNavigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`block px-4 py-2 text-sm ${
                        location.pathname === item.href
                          ? 'text-accent bg-section-bg'
                          : 'text-dark hover:bg-section-bg hover:text-primary'
                      }`}
                      role="menuitem"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Ícono del carrito actualizado */}
            <Link
              to="/cart"
              className="flex items-center px-3 py-2 rounded-md text-dark hover:text-primary transition-colors relative"
              aria-label="Carrito de compras"
            >
              <ShoppingCart className="h-6 w-6" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-primary text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>

          {/* Botones móviles */}
          <div className="md:hidden flex items-center gap-4">
            {/* Ícono del carrito en móvil actualizado */}
            <Link
              to="/cart"
              className="relative"
              aria-label="Carrito de compras"
            >
              <ShoppingCart className="h-6 w-6 text-dark" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-primary text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  {cartCount}
                </span>
              )}
            </Link>

            <button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-dark hover:text-primary focus:outline-none transition-colors"
              aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
              aria-expanded={isOpen}
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Menú móvil */}
      {isOpen && (
        <div className="md:hidden" role="navigation" aria-label="Menú principal">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {mainNavigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  location.pathname === item.href
                    ? 'text-accent bg-section-bg'
                    : 'text-dark hover:text-primary hover:bg-section-bg'
                }`}
                onClick={() => setIsOpen(false)}
                role="link"
                aria-current={location.pathname === item.href ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
            <button typeof='button' title='Categorías'
              type="button"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-dark hover:text-primary hover:bg-section-bg"
              aria-expanded={dropdownOpen}
            >
              Categorías
              <ChevronDown className="inline ml-1 h-4 w-4" />
            </button>
            {dropdownOpen && (
              <div className="pl-4" role="menu">
                {dropdownNavigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`block px-3 py-2 rounded-md text-base font-medium ${
                      location.pathname === item.href
                        ? 'text-accent bg-section-bg'
                        : 'text-dark hover:text-primary hover:bg-section-bg'
                    }`}
                    role="menuitem"
                    onClick={() => {
                      setIsOpen(false);
                      setDropdownOpen(false);
                    }}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            )}
            
            {/* Enlace al carrito actualizado */}
            <Link
              to="/cart"
              className="block px-3 py-2 rounded-md text-base font-medium text-dark hover:text-primary hover:bg-section-bg"
              onClick={() => setIsOpen(false)}
              aria-label="Ir al carrito de compras"
            >
              <div className="flex items-center gap-2 relative">
                <ShoppingCart className="h-5 w-5" />
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                    {cartCount}
                  </span>
                )}
              </div>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};